import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_SKILLS_REQUEST = 'LOAD_SKILLS_REQUEST';
export const LOAD_SKILLS_SUCCESS = 'LOAD_SKILLS_SUCCESS';
export const LOAD_SKILLS_FAIL = 'LOAD_SKILLS_FAIL';

export const POST_SKILLS_REQUEST = 'POST_SKILLS_REQUEST';
export const POST_SKILLS_SUCCESS = 'POST_SKILLS_SUCCESS';
export const POST_SKILLS_FAIL = 'POST_SKILLS_FAIL';

export const PUT_SKILLS_REQUEST = 'PUT_SKILLS_REQUEST';
export const PUT_SKILLS_SUCCESS = 'PUT_SKILLS_SUCCESS';
export const PUT_SKILLS_FAIL = 'PUT_SKILLS_FAIL';

export const DELETE_SKILLS_REQUEST = 'DELETE_SKILLS_REQUEST';
export const DELETE_SKILLS_SUCCESS = 'DELETE_SKILLS_SUCCESS';
export const DELETE_SKILLS_FAIL = 'DELETE_SKILLS_FAIL';

export const LOAD_SKILL_SCALES_REQUEST = 'LOAD_SKILL_SCALES_REQUEST';
export const LOAD_SKILL_SCALES_SUCCESS = 'LOAD_SKILL_SCALES_SUCCESS';
export const LOAD_SKILL_SCALES_FAIL = 'LOAD_SKILL_SCALES_FAIL';

export const POST_SKILL_SCALES_REQUEST = 'POST_SKILL_SCALES_REQUEST';
export const POST_SKILL_SCALES_SUCCESS = 'POST_SKILL_SCALES_SUCCESS';
export const POST_SKILL_SCALES_FAIL = 'POST_SKILL_SCALES_FAIL';

export const PUT_SKILL_SCALES_REQUEST = 'PUT_SKILL_SCALES_REQUEST';
export const PUT_SKILL_SCALES_SUCCESS = 'PUT_SKILL_SCALES_SUCCESS';
export const PUT_SKILL_SCALES_FAIL = 'PUT_SKILL_SCALES_FAIL';

export const DELETE_SKILL_SCALES_REQUEST = 'DELETE_SKILL_SCALES_REQUEST';
export const DELETE_SKILL_SCALES_SUCCESS = 'DELETE_SKILL_SCALES_SUCCESS';
export const DELETE_SKILL_SCALES_FAIL = 'DELETE_SKILL_SCALES_FAIL';

export const LOAD_SCALE_LEVELS_REQUEST = 'LOAD_SCALE_LEVELS_REQUEST';
export const LOAD_SCALE_LEVELS_SUCCESS = 'LOAD_SCALE_LEVELS_SUCCESS';
export const LOAD_SCALE_LEVELS_FAIL = 'LOAD_SCALE_LEVELS_FAIL';

export const POST_SCALE_LEVELS_REQUEST = 'POST_SCALE_LEVELS_REQUEST';
export const POST_SCALE_LEVELS_SUCCESS = 'POST_SCALE_LEVELS_SUCCESS';
export const POST_SCALE_LEVELS_FAIL = 'POST_SCALE_LEVELS_FAIL';

export const PUT_SCALE_LEVELS_REQUEST = 'PUT_SCALE_LEVELS_REQUEST';
export const PUT_SCALE_LEVELS_SUCCESS = 'PUT_SCALE_LEVELS_SUCCESS';
export const PUT_SCALE_LEVELS_FAIL = 'PUT_SCALE_LEVELS_FAIL';

export const DELETE_SCALE_LEVELS_REQUEST = 'DELETE_SCALE_LEVELS_REQUEST';
export const DELETE_SCALE_LEVELS_SUCCESS = 'DELETE_SCALE_LEVELS_SUCCESS';
export const DELETE_SCALE_LEVELS_FAIL = 'DELETE_SCALE_LEVELS_FAIL';

const loadSkillsRequest = () => ({ type: LOAD_SKILLS_REQUEST });
const loadSkillsSuccess = (skills) => ({ type: LOAD_SKILLS_SUCCESS, skills });
const loadSkillsFail = () => ({ type: LOAD_SKILLS_FAIL });

const postSkillRequest = () => ({ type: POST_SKILLS_REQUEST });
const postSkillSuccess = (skill) => ({ type: POST_SKILLS_SUCCESS, skill });
const postSkillFail = () => ({ type: POST_SKILLS_FAIL });

const putSkillRequest = () => ({ type: PUT_SKILLS_REQUEST });
const putSkillSuccess = (skill) => ({ type: PUT_SKILLS_SUCCESS, skill });
const putSkillFail = () => ({ type: PUT_SKILLS_FAIL });

const deleteSkillRequest = () => ({ type: DELETE_SKILLS_REQUEST });
const deleteSkillSuccess = (skill) => ({ type: DELETE_SKILLS_SUCCESS, skill });
const deleteSkillFail = () => ({ type: DELETE_SKILLS_FAIL });

const loadSkillScalesRequest = () => ({ type: LOAD_SKILL_SCALES_REQUEST });
const loadSkillScalesSuccess = (scales) => ({ type: LOAD_SKILL_SCALES_SUCCESS, scales });
const loadSkillScalesFail = () => ({ type: LOAD_SKILL_SCALES_FAIL });

const postSkillScaleRequest = () => ({ type: POST_SKILL_SCALES_REQUEST });
const postSkillScaleSuccess = (scale) => ({ type: POST_SKILL_SCALES_SUCCESS, scale });
const postSkillScaleFail = () => ({ type: POST_SKILL_SCALES_FAIL });

const putSkillScaleRequest = () => ({ type: PUT_SKILL_SCALES_REQUEST });
const putSkillScaleSuccess = (scale) => ({ type: PUT_SKILL_SCALES_SUCCESS, scale });
const putSkillScaleFail = () => ({ type: PUT_SKILL_SCALES_FAIL });

const deleteSkillScaleRequest = () => ({ type: DELETE_SKILL_SCALES_REQUEST });
const deleteSkillScaleSuccess = (scale) => ({ type: DELETE_SKILL_SCALES_SUCCESS, scale });
const deleteSkillScaleFail = () => ({ type: DELETE_SKILL_SCALES_FAIL });

const loadScaleLevelsRequest = () => ({ type: LOAD_SCALE_LEVELS_REQUEST });
const loadScaleLevelsSuccess = (levels) => ({ type: LOAD_SCALE_LEVELS_SUCCESS, levels });
const loadScaleLevelsFail = () => ({ type: LOAD_SCALE_LEVELS_FAIL });

const postScaleLevelRequest = () => ({ type: POST_SCALE_LEVELS_REQUEST });
const postScaleLevelSuccess = (level) => ({ type: POST_SCALE_LEVELS_SUCCESS, level });
const postScaleLevelFail = () => ({ type: POST_SCALE_LEVELS_FAIL });

const putScaleLevelRequest = () => ({ type: PUT_SCALE_LEVELS_REQUEST });
const putScaleLevelSuccess = (level) => ({ type: PUT_SCALE_LEVELS_SUCCESS, level });
const putScaleLevelFail = () => ({ type: PUT_SCALE_LEVELS_FAIL });

const deleteScaleLevelRequest = () => ({ type: DELETE_SCALE_LEVELS_REQUEST });
const deleteScaleLevelSuccess = (level) => ({ type: DELETE_SCALE_LEVELS_SUCCESS, level });
const deleteScaleLevelFail = () => ({ type: DELETE_SCALE_LEVELS_FAIL });

export const loadSkills = () => (dispatch) => {
  dispatch(loadSkillsRequest());
  return communicate({ url: 'Skills' })
    .then(({ data }) => dispatch(loadSkillsSuccess(data.Data)))
    .catch((err) => {
      toastrError(err);
      dispatch(loadSkillsFail());
    });
};

export const postSkill = (params) => (dispatch) => {
  dispatch(postSkillRequest());
  return communicate({ url: 'Skills', method: 'post', data: params }).then((response) => {
    dispatch(postSkillSuccess(response.data.Data));
    toastrSuccess(response);
    return response.data.Data;
  }).catch((e) => {
    dispatch(postSkillFail(e));
    toastrError(e);
  });
};

export const putSkill = (department) => (dispatch) => {
  dispatch(putSkillRequest(department));
  return communicate({ url: 'Skills', method: 'put', data: department })
    .then((response) => {
      dispatch(putSkillSuccess(response.data.Data));
      toastrSuccess(response);
      return response.data.Data;
    }).catch((e) => {
      dispatch(putSkillFail(e));
      toastrError(e);
    });
};

export const deleteSkill = (params) => (dispatch) => {
  dispatch(deleteSkillRequest());
  return communicate({ url: 'Skills', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteSkillSuccess(params));
    }).catch((e) => {
      dispatch(deleteSkillFail(e));
      toastrError(e);
    });
};

export const loadSkillScales = () => (dispatch) => {
  dispatch(loadSkillScalesRequest());
  return communicate({ url: 'SkillScales' })
    .then(({ data }) => dispatch(loadSkillScalesSuccess(data.Data)))
    .catch((err) => {
      toastrError(err);
      dispatch(loadSkillScalesFail());
    });
};

export const postSkillScale = (params) => (dispatch) => {
  dispatch(postSkillScaleRequest());
  return communicate({ url: 'SkillScales', method: 'post', data: params }).then((response) => {
    dispatch(postSkillScaleSuccess(response.data.Data));
    toastrSuccess(response);
    return response.data.Data;
  }).catch((e) => {
    dispatch(postSkillScaleFail(e));
    toastrError(e);
  });
};

export const putSkillScale = (department) => (dispatch) => {
  dispatch(putSkillScaleRequest(department));
  return communicate({ url: 'SkillScales', method: 'put', data: department })
    .then((response) => {
      dispatch(putSkillScaleSuccess(response.data.Data));
      toastrSuccess(response);
      return response.data.Data;
    }).catch((e) => {
      dispatch(putSkillScaleFail(e));
      toastrError(e);
    });
};

export const deleteSkillScale = (params) => (dispatch) => {
  dispatch(deleteSkillScaleRequest());
  return communicate({ url: 'SkillScales', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteSkillScaleSuccess(params));
    }).catch((e) => {
      dispatch(deleteSkillScaleFail(e));
      toastrError(e);
    });
};

export const loadScaleLevels = () => (dispatch) => {
  dispatch(loadScaleLevelsRequest());
  return communicate({ url: 'SkillScaleLevels' })
    .then(({ data }) => dispatch(loadScaleLevelsSuccess(data.Data)))
    .catch((err) => {
      toastrError(err);
      dispatch(loadScaleLevelsFail());
    });
};

export const postScaleLevel = (params) => (dispatch) => {
  dispatch(postScaleLevelRequest());
  return communicate({ url: 'SkillScaleLevels', method: 'post', data: params }).then((response) => {
    dispatch(postScaleLevelSuccess(response.data.Data));
    toastrSuccess(response);
    return response.data.Data;
  }).catch((e) => {
    dispatch(postScaleLevelFail(e));
    toastrError(e);
  });
};

export const putScaleLevel = (department) => (dispatch) => {
  dispatch(putScaleLevelRequest(department));
  return communicate({ url: 'SkillScaleLevels', method: 'put', data: department })
    .then((response) => {
      dispatch(putScaleLevelSuccess(response.data.Data));
      toastrSuccess(response);
      return response.data.Data;
    }).catch((e) => {
      dispatch(putScaleLevelFail(e));
      toastrError(e);
    });
};

export const deleteScaleLevel = (params) => (dispatch) => {
  dispatch(deleteScaleLevelRequest());
  return communicate({ url: 'SkillScaleLevels', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteScaleLevelSuccess(params));
    }).catch((e) => {
      dispatch(deleteScaleLevelFail(e));
      toastrError(e);
    });
};
